import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Post from './page/Post';
import Empty from './page/404';
import { basename, getTenant } from './tenant';

import CONFIG from "./config";

// 非首屏路由按需加载：文章页（最常见的落地页）留在主包，列表 / 活跃度（热力图库）/ 聊天 / 站点列表各自成块
const PostList = lazy(() => import('./page/PostList'));
const Chat = lazy(() => import('./page/Chat'));
const Activity = lazy(() => import('./page/Activity'));
const Sites = lazy(() => import('./page/Sites'));


// 设置路由
function App() {

    // 根路径（没有用户名前缀）是站点列表；/<username>/… 是该用户的公开站，路由全部挂在 basename 下
    if (!getTenant()) return <Suspense fallback={null}><Sites /></Suspense>

    return (
        <Router basename={basename()}>
            <Suspense fallback={null}>
                <Routes >
                    <Route exact path="/" element={<Post title={CONFIG.title} />} />
                    <Route exact path="/chat" element={<Chat />} />
                    <Route path="/post/*" element={<Post title={CONFIG.title} />} />
                    <Route path="/notes/" element={<PostList title={CONFIG.title} />} />
                    <Route path="/activity" element={<Activity />} />

                    <Route path="/404/" element={<Empty title={CONFIG.title} />} />
                    <Route path="*" element={<Empty title={CONFIG.title} />} />
                </Routes>
            </Suspense>
        </Router>
    )
}
export default App;
